<template>
  <router-view />
</template>
<script>
export default {
  name: 'Multishop',
};
</script>
